import { SVGIcon } from '@superops/super-icons';
import { ActionList, Popover } from '@superops/ui-design-system';
import React, { useCallback, useState } from 'react';
import {
  EventEmitter,
  getTranslatedText,
  useActivityTracker
} from '@nile/components';
import { useIntl } from 'react-intl';

function CloseChat(props) {
  const { setTimerPopupData, threadData, ticketData, closeSession } = props;
  const intl = useIntl();
  const [popoverActive, setPopoverActive] = useState(false);

  const togglePopoverActive = useCallback(() => {
    setPopoverActive((prevState) => !prevState);
  }, []);

  const activator = (
    <div onClick={togglePopoverActive} aria-hidden>
      <SVGIcon color="white" name="EndChat" />
    </div>
  );
  return (
    <Popover
      active={popoverActive}
      activator={activator}
      onClose={togglePopoverActive}
      preferredAlignment="right"
      customClassName="black"
    >
      <ActionList
        actionRole="menuitem"
        items={[
          {
            iconName: 'ChatIcon',
            content: getTranslatedText(
              intl,
              'app.chat.action.close.convert.worklog'
            ),
            onAction: () => {
              EventEmitter.dispatch('closeSessionAndConvertWorklog');
              togglePopoverActive();
              try {
                useActivityTracker({
                  event: 'CLOSE_CHAT - CLOSE SESSSION AND WORKLOG'
                });
              } catch (err) {
                console.log(err);
              }
              if (setTimerPopupData) setTimerPopupData({ ...ticketData });
            }
          },
          {
            iconName: 'TicketOutline',
            content: getTranslatedText(
              intl,
              'app.chat.action.close.ticket.convert.worklog'
            ),
            onAction: () => {
              EventEmitter.dispatch('closeTicketAndConvertWorklog');
              try {
                useActivityTracker({
                  event: 'CLOSE_CHAT - CLOSE SESSSION ,TICKET AND WORKLOG'
                });
              } catch (err) {
                console.log(err);
              }
              togglePopoverActive();
              if (setTimerPopupData) setTimerPopupData({ ...ticketData });
            }
          },
          {
            iconName: 'Close',
            content: getTranslatedText(intl, 'app.chat.action.close.session'),
            onAction: () => {
              try {
                useActivityTracker({
                  event: 'CLOSE_CHAT - CLOSE SESSSION'
                });
              } catch (err) {
                console.log(err);
              }
              closeSession({ convThread: threadData });
              togglePopoverActive();
            }
          }
        ]}
      />
    </Popover>
  );
}

export default CloseChat;
